import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };
  const handleNecessaryOnly = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setIsVisible(false);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-[#1a2e4a] border-t-[3px] border-[#e8c84a] shadow-lg z-50" data-id="element-110">
      <div className="max-w-[900px] mx-auto px-[20px] py-[20px]" data-id="element-111">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-[16px]" data-id="element-112">
          <div className="flex-1" data-id="element-113">
            <p className="text-[13px] text-white leading-[1.6] mb-[8px]" data-id="element-114">
              Diese Website verwendet Cookies, um Ihnen die bestmögliche
              Nutzererfahrung zu bieten. Durch die weitere Nutzung der Website
              stimmen Sie der Verwendung von Cookies zu.
            </p>
            <Link to="/datenschutz" className="text-[12px] text-[#e8c84a] hover:text-white underline" data-id="element-115">
              Mehr erfahren in unserer Datenschutzerklärung
            </Link>
          </div>
          <div className="flex gap-[12px] flex-shrink-0" data-id="element-116">
            <button onClick={handleNecessaryOnly} className="bg-transparent text-white border border-[#8da4bc] rounded-[4px] px-[16px] py-[8px] text-[12px] font-medium cursor-pointer hover:bg-[#2a3e5a]" data-id="element-117">
              Nur notwendige
            </button>
            <button onClick={handleAccept} className="bg-[#e8c84a] text-[#1a2e4a] border-none rounded-[4px] px-[20px] py-[8px] text-[12px] font-semibold cursor-pointer hover:bg-[#f0d05a]" data-id="element-118">
              Akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>;
};